module.exports = __webpack_public_path__ + "img/12AzhkUkBYZ-p4x8Ku1aPi.5fd40ff8.svg";